// Stable, unique React keys derived from item content (duplicates get a #n suffix).
export const withKeys = (items = [], toKey = String) => {
  const seen = {};
  return items.map((item) => {
    const base = toKey(item);
    seen[base] = (seen[base] || 0) + 1;
    return [seen[base] > 1 ? `${base}#${seen[base]}` : base, item];
  });
};
